import { render, staticRenderFns } from "./headerNew.vue?vue&type=template&id=2b7063da&scoped=true&"
import script from "./headerNew.vue?vue&type=script&lang=js&"
export * from "./headerNew.vue?vue&type=script&lang=js&"
import style0 from "./headerNew.vue?vue&type=style&index=0&id=2b7063da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7063da",
  null
  
)

export default component.exports